<template>
	<div class="camera-wrapper">
		<div v-if="error" class="flex justify-center items-center bg-grey-1 py-40">
			<div>
				<IconVideoSlash />
				<div></div>
			</div>
		</div>

		<div v-else>
			<!-- Camera Preview -->
			<video ref="video" autoplay playsinline v-show="cameraOn && !photoTaken"
				class="w-full max-w-md border rounded-md shadow-md"></video>

			<!-- Photo Preview -->
			<canvas v-show="photoTaken" ref="canvas" class="w-full max-w-md border rounded-md shadow-md"></canvas>

			<!-- Error Message -->
			<p v-if="error" class="text-red-500">{{ error }}</p>
		</div>
	</div>
</template>

<script>
import IconVideoSlash from './icons/IconVideoSlash.vue'

export default {
	props: {
		cameraOn: {
			type: Boolean,
			required: true,
		},
	},
	components: {
		IconVideoSlash,
	},
	data() {
		return {
			stream: null, // Media stream from camera
			photo: null, // Captured photo as a data URL
			error: null, // Error message
			isVideo: true,
			photoTaken: false,
			photoBlob: null,
		}
	},
	watch: {
		cameraOn: {
			immediate: true,
			handler(newValue) {
				if (newValue) {
					this.initCamera()
				} else {
					this.stopCamera()
				}
			},
		},
	},
	beforeDestroy() {
		this.stopCamera()
	},
	methods: {
		// Initialize the camera
		async initCamera() {
			this.error = null // Clear previous errors
			try {
				this.stream = await navigator.mediaDevices.getUserMedia({
					video: true,
				})
				const videoElement = this.$refs.video
				videoElement.srcObject = this.stream
				this.$emit("camera-ready", true) // Notify parent that the camera is ready
			} catch (err) {
				this.error = "Unable to access the camera."

				this.$emit("error", err) // Emit error to parent
				console.error("camera", err.name)
			}
		},

		canvasToBlob(canvas) {
			return new Promise((resolve, reject) => {
				canvas.toBlob((blob) => {
					if (!blob) {
						return reject(new Error("Failed to convert canvas to blob."))
					}

					return resolve(blob)
				}, "image/jpeg")
			})
		},

		// Capture a photo
		async capturePhoto() {
			try {

				const videoElement = this.$refs.video
				const canvasElement = this.$refs.canvas

				const context = canvasElement.getContext("2d")
				canvasElement.width = videoElement.videoWidth
				canvasElement.height = videoElement.videoHeight

				// Draw video frame to canvas
				context.drawImage(
					videoElement,
					0,
					0,
					canvasElement.width,
					canvasElement.height
				)

				this.setPhotoTaken(true)

				// Save the photo as a data URL
				this.photo = canvasElement.toDataURL("image/png")

				// save the photo as a blob
				// Convert canvas to Blob (image/jpeg format)
				this.photoBlob = await this.canvasToBlob(canvasElement)

				console.log('photoBlob', this.photoBlob)

				this.$emit("photo-taken", this.photo, this.photoBlob) // Emit photo data to parent
			} catch (err) {
				this.error = "Failed to capture photo."
				this.$emit("error", err) // Emit error to parent
			}
		},
		// Stop the camera
		stopCamera() {
			if (this.stream) {
				const tracks = this.stream.getTracks()
				tracks.forEach((track) => track.stop())
				this.stream = null
			}
		},

		setPhotoTaken(value) {
			this.photoTaken = value
		}
	},
}
</script>

<style scoped>
.camera-wrapper {
	/* margin: 20px; */
	/* text-align: center; */
}

/* Add the mirrored effect */
video {
	transform: scaleX(-1);
	/* Flip the video horizontally */
	width: 100%;
}

canvas {
	width: 100%;
}
</style>
